<template>
  <div>
    <el-form
      :model="searchData"
      label-position="left"
      inline
      v-if="$store.state.userStatus == 'administrator'"
    >
      <!-- <el-form-item label="日期">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="searchData.date"
          type="date"
        >
        </el-date-picker>
      </el-form-item> -->
      <el-form-item label="高代號">
        <el-input v-model="searchData.agent_id" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getDashboard">查詢</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="12" v-if="dataList" style="margin-top:15px">
      <el-col :span="4" v-if="$store.state.userStatus != 'agentSub'">
        <el-card shadow="always">
          <h2>
            {{
              $store.state.userStatus == "manager" ? "平台費總計" : "可用餘額"
            }}
          </h2>
          <h3>
            {{
              dataList.withdraw_balance[currency] != undefined
                ? dataList.withdraw_balance[currency] || 0
                : dataList.withdraw_balance | decimalPoint
            }}
          </h3>
        </el-card>
      </el-col>
      <el-col
        :span="4"
        v-if="
          $store.state.userStatus == 'customer' ||
            $store.state.userStatus == 'customerSub' ||
            $store.state.userStatus == 'agent'
        "
      >
        <el-card shadow="always">
          <h2>
            凍結金額
          </h2>
          <h3>
            {{
              dataList.freeze_balance[currency] != undefined
                ? dataList.freeze_balance[currency] || 0
                : dataList.freeze_balance | decimalPoint
            }}
          </h3>
        </el-card>
      </el-col>
      <el-col :span="4" v-if="$store.state.userStatus != 'agentSub'">
        <el-card shadow="always">
          <h2>
            今日成交量
          </h2>
          <h3>
            {{
              (dataList.withdraw_balance[currency] != undefined
                ? dataList.today_income[currency] || 0
                : dataList.today_income) | decimalPoint
            }}
          </h3>
        </el-card>
      </el-col>
      <el-col :span="4" v-if="$store.state.userStatus != 'agentSub'">
        <el-card shadow="always">
          <h2>
            昨日成交量
          </h2>
          <h3>
            {{
              (dataList.withdraw_balance[currency] != undefined
                ? dataList.yesterday_income[currency] || 0
                : dataList.yesterday_income) | decimalPoint
            }}
          </h3>
        </el-card>
      </el-col>
      <el-col :span="4" v-if="dataList.cost_fee || dataList.cost_fee === 0">
        <el-card shadow="always">
          <h2>
            今日成功單數/失敗單數
          </h2>
          <h3>
            {{
              (dataList.withdraw_balance[currency] != undefined
                ? dataList.success_count[currency] || 0
                : dataList.success_count) | decimalPoint
            }}/{{
              (dataList.withdraw_balance[currency] != undefined
                ? dataList.fail_count[currency] || 0
                : dataList.fail_count) | decimalPoint
            }}
          </h3>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="12" style="margin-top:15px">
      <el-col :span="4" style="margin-bottom:10px">
        <el-card shadow="always">
          <h2>
            代付金額
          </h2>
          <h3>
            {{ dailyData.p_amount || 0 | decimalPoint }}
          </h3>
        </el-card>
      </el-col>
      <el-col :span="4" style="margin-bottom:10px">
        <el-card shadow="always">
          <h2>
            代付筆數
          </h2>
          <h3>
            {{ dailyData.p_count || 0 | decimalPoint }}
          </h3>
        </el-card>
      </el-col>
      <el-col :span="4" style="margin-bottom:10px">
        <el-card shadow="always">
          <h2>
            代付手續費
          </h2>
          <h3>
            {{ dailyData.p_fee || 0 | decimalPoint }}
          </h3>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="12" style="margin-top:15px">
      <div v-if="$permission('index.stats7.grant')">
        <el-col
          :span="4"
          v-for="(list, index) in grantList"
          :key="index"
          style="margin-bottom:10px"
          v-show="list.show"
        >
          <el-card shadow="always">
            <h2>{{ list.name }}未撥款</h2>
            <h3>
              {{ list.sum || 0 | decimalPoint }}
            </h3>
          </el-card>
        </el-col>
      </div>
      <el-col
        :span="4"
        style="margin-bottom:10px"
        v-if="
          $store.state.userStatus == 'customer' ||
            $store.state.userStatus == 'customerSub'
        "
      >
        <el-card shadow="always">
          <h2>未撥款總和</h2>
          <h3>
            {{
              grantList.reduce((total, item) => total + (item.sum || 0), 0) ||
                0 | decimalPoint
            }}
          </h3>
        </el-card>
      </el-col>
    </el-row>
    <h2
      style="text-align:center;margin-top:15px"
      v-if="$store.state.userStatus != 'agentSub'"
    >
      登入紀錄
    </h2>
    <el-table
      v-if="$store.state.userStatus != 'agentSub'"
      stripe
      :data="loginList"
      border
      style="width: 100%;margin-top:18px"
    >
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="datetime"
        label="登入時間 "
      >
      </el-table-column>
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="ip"
        label="登入IP地址"
      >
      </el-table-column>
      <el-table-column
        :min-width="100"
        header-align="center"
        align="center"
        prop="status"
        label="訊息"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchData: {
        date: this.$returnTime(new Date())
      },
      dataList: false,
      currency: "TW",
      loginList: [],
      grantList: [
        { type: 0, name: "ATM", sum: "", date: "3", show: true },
        { type: 1, name: "7-11", sum: "", date: "11", show: true },
        { type: 2, name: "全家", sum: "", date: "11", show: true },
        { type: 3, name: "ATM T+0", sum: "", date: "0" },
        { type: 4, name: "ATM T+1", sum: "", date: "1" },
        { type: 5, name: "ATM T+2", sum: "", date: "2" }
      ],
      dailyData: {
        p_count: 0,
        p_amount: 0,
        p_fee: 0
      }
    };
  },
  computed: {
    permissions() {
      return this.$store.state.permissions;
    }
  },
  watch: {
    permissions() {
      this.getDashboard();
    }
  },
  methods: {
    getData() {
      this.$http.get(`/back/statistics/dashboard`).then(res => {
        if (res.data.code == 0) {
          this.dataList = res.data.data;
        }
      });
    },
    getLoginLog() {
      this.$http.get(`/back/users/selfLoginLog`).then(res => {
        if (res.data.code == 0) {
          this.loginList = res.data.data;
        }
      });
    },
    returnDate(date) {
      var today = new Date(); // 获取当前日期
      var year = today.getFullYear();
      today.setDate(today.getDate() + date * 1); // 加上'x'天数
      // 从日期中提取年份、月份和日期
      var month = (today.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始计数，使用padStart方法补齐两位数
      var day = today
        .getDate()
        .toString()
        .padStart(2, "0"); // 使用padStart方法补齐两位数

      // 格式化日期
      var formattedDate = year + "-" + month + "-" + day;
      return formattedDate;
    },
    getDashboard() {
      if (this.$store.state.userStatus == "administrator") {
        if (!this.searchData.agent_id) {
          this.$message.error("請輸入高代號");
          return;
        }
      }
      let grantList = this.grantList;

      if (this.$permission("index.stats7.grant")) {
        grantList.forEach(e => {
          this.$http
            .get(
              `/back/stats/grant?grant_type=${e.type}&agent_id=${
                this.searchData.agent_id
              }&perPage=10000&date_start=${this.returnDate(
                e.date == 0 ? 0 : 1
              )}&date_end=${this.returnDate(e.date)}`
            )
            .then(res => {
              if (res.data.code == 0) {
                e.sum = res.data.data.record?.data.reduce((a, b) => {
                  return a * 1 + b.amount_customer * 1;
                }, 0);
                let atm = "";
                grantList.forEach(e => {
                  if (e.name.indexOf("ATM") != -1) {
                    if (!atm) {
                      e.name = "ATM";
                      atm = e;
                      return;
                    }
                    if (e.sum) {
                      atm.sum = atm.sum * 1 + e.sum * 1;
                    }
                  }
                });
                this.grantList = grantList;
              }
            });
        });
      }
      if (this.$permission("index.customers.dailySummary")) {
        let endDate = this.searchData.date;
        this.$http
          .post(`/back/customers/getDailySummary`, {
            date_start: this.searchData.date,
            date_end: endDate
          })
          .then(res => {
            if (res.data.code == 0) {
              let resData = res.data.data;
              let dailyData = this.dailyData;
              resData.forEach(e => {
                dailyData.p_count += e.p_count * 1;
                dailyData.p_amount += e.p_amount * 1;
                dailyData.p_fee += e.p_fee * 1;
              });
              this.dailyData = dailyData;
            }
          });
      }
    }
  },
  created() {
    this.getData();
    this.getLoginLog();
    if (this.$store.state.permissions.length) {
      this.getDashboard();
    }
  }
};
</script>

<style lang="scss" socped>
h2 {
  line-height: 26px;
}
</style>
